/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtifactToolCallRequestContent
 */
export interface ArtifactToolCallRequestContent {
    /**
     * 
     * @type {object}
     * @memberof ArtifactToolCallRequestContent
     */
    arguments: object;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequestContent
     */
    tool: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactToolCallRequestContent
     */
    callId: string;
}

/**
 * Check if a given object implements the ArtifactToolCallRequestContent interface.
 */
export function instanceOfArtifactToolCallRequestContent(value: object): value is ArtifactToolCallRequestContent {
    if (!('arguments' in value) || value['arguments'] === undefined) return false;
    if (!('tool' in value) || value['tool'] === undefined) return false;
    if (!('callId' in value) || value['callId'] === undefined) return false;
    return true;
}

export function ArtifactToolCallRequestContentFromJSON(json: any): ArtifactToolCallRequestContent {
    return ArtifactToolCallRequestContentFromJSONTyped(json, false);
}

export function ArtifactToolCallRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactToolCallRequestContent {
    if (json == null) {
        return json;
    }
    return {
        
        'arguments': json['arguments'],
        'tool': json['tool'],
        'callId': json['callId'],
    };
}

export function ArtifactToolCallRequestContentToJSON(json: any): ArtifactToolCallRequestContent {
    return ArtifactToolCallRequestContentToJSONTyped(json, false);
}

export function ArtifactToolCallRequestContentToJSONTyped(value?: ArtifactToolCallRequestContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arguments': value['arguments'],
        'tool': value['tool'],
        'callId': value['callId'],
    };
}

